module.exports = __webpack_public_path__ + "img/feature-12-1.7ff75860.png";